import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isInternalUrl } from '../../../utils';

const RoutableNotEditableLink = ({ href, target = '', ...otherProps }) => {
  if (href && isInternalUrl(href)) {
    return <Link to={href} {...otherProps} />;
  }
  //eslint-disable-next-line
  return <a href={href} target={target} rel="nofollow" {...otherProps} />;
};

RoutableNotEditableLink.propTypes = {
  href: PropTypes.string.isRequired,
  target: PropTypes?.string,
};

export default RoutableNotEditableLink;
